import { CustomButton, CustomInputSelect } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import UsersSupervisionDatatableHandler from '../containers/datatables/UsersSupervisionDatatableHandler/UsersSupervisionDatatableHandler';

const data: any[] = [{}, {}, {}, {}, {}, {}, {}, {}];
const columns = (
  handleEdit: (e: any) => void,
  handleDelete: (e: any) => void
) => [
  {
    accessorKey: 'show',
    id: 'id',
    header: 'Nom Complet',
    cell: 'ID',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id2',
    header: "Nom d'utilisateur",
    cell: 'Micke',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id3',
    header: 'Pays',
    cell: 'Cameroun',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id4',
    header: 'Téléphone',
    cell: '6xxxxxxxxxx',
  },
  {
    accessorKey: 'accessorkey3',
    id: 'id5',
    header: 'Action',
    cell: (info: any) => (
      <CC.Box>
        <CustomButton onClick={() => handleEdit(info)}>Edit</CustomButton>
        <CustomButton onClick={() => handleDelete(info)} variant="ghost" ml="2">
          Delete
        </CustomButton>
      </CC.Box>
    ),
  },
];

export default function UsersSupervision() {
  const editUsersModal = React.useRef<any>(null);
  const deleteUsersModal = React.useRef<any>(null);
  const borderColor = CC.useColorModeValue('gray.200', 'gray.600');
  const bgColor = CC.useColorModeValue('gray.50', 'gray.700');

  const handleEdit = (row: any) => {
    // console.log(row.getValue());
    editUsersModal?.current?.onOpen();
  };

  const handleDelete = (row: any) => {
    deleteUsersModal?.current?.onOpen();
  };

  return (
    <>
      <CC.Box>
        <CC.Heading as="h2" size="lg">
          Supervision des utilisateurs
        </CC.Heading>

        <CC.Text mb="4" color="gray.600">
          {/* Définir le comportement d'accès aux sessions */}
        </CC.Text>
      </CC.Box>

      <CC.Flex
        bg={bgColor}
        minH="16"
        p="4"
        alignItems="center"
        border="1px"
        borderColor={borderColor}
        rounded="sm"
        flexDirection={{ base: 'column', md: 'row' }}
      >
        <CC.Text>Compte utilisateur</CC.Text>
        <CC.RadioGroup defaultValue="1">
          <CC.Flex
            direction="row"
            flexDirection={{ base: 'column', md: 'row' }}
          >
            <CC.Radio value="1" mx="2">
              Tous
            </CC.Radio>
            <CC.Radio value="2" mx="2">
              Actif
            </CC.Radio>
            <CC.Radio value="3" mx="2">
              Vérouillés
            </CC.Radio>
            <CC.Radio value="4" mx="2">
              Expirés
            </CC.Radio>
          </CC.Flex>
        </CC.RadioGroup>
      </CC.Flex>

      <CC.Box mt="10">
        {/* <CustomReactTable
          data={data}
          columns={columns(handleEdit, handleDelete)}
        /> */}
        <UsersSupervisionDatatableHandler />
      </CC.Box>

      <CustomAppModal
        title="Editer Le Status des utilisateurs"
        ref={editUsersModal}
        actionBtnText="Editer"
        actionBtnClick={() => editUsersModal?.current?.onClose()}
      >
        <CustomFormControl label="Status">
          <CustomInputSelect
            meta={{
              name: 'status',
              options: [
                { label: 'Actif', value: 'active' },
                { label: 'Vérouillé', value: 'lock' },
              ],
            }}
          />
        </CustomFormControl>
      </CustomAppModal>

      <CustomAppModal
        title="Confirmer la suppression"
        ref={deleteUsersModal}
        actionBtnText="Supprimer"
        actionBtnClick={() => deleteUsersModal?.current?.onClose()}
      >
        <CC.Text>Voulez-vous vraiment supprimer ?</CC.Text>
      </CustomAppModal>
    </>
  );
}
